export const routeConfig = {
  meta: {
    title: '供应商审批'
  }
};

